import { useSyncExternalStore } from "react";
import { onlineManager } from "@tanstack/react-query";

const subscribe = (onChange: () => void) => onlineManager.subscribe(onChange);
const readOnline = () => onlineManager.isOnline();

export function useNetworkOnline(): boolean {
  return useSyncExternalStore(subscribe, readOnline, readOnline);
}
